module.exports = __webpack_public_path__ + "static/media/aboutmyself.c0c6cf3a.svg";